import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDateSegment } from '@react-aria/datepicker';
import { useRef } from 'react';
const DateSegment = ({ className, segment, state, }) => {
    const dateSegmentRef = useRef(null);
    const { segmentProps } = useDateSegment(segment, state, dateSegmentRef);
    return (_jsx("div", { ...segmentProps, ref: dateSegmentRef, className: buildClassName('focus-visible:bg-primary-blue/30 rounded-sm px-[1px] focus-visible:outline-none', className), children: segment.text }));
};
export default DateSegment;
//# sourceMappingURL=DateSegment.js.map